import { sendGet, sendPost } from "./axios";

// eslint-disable-next-line import/prefer-default-export
export const signin = (payload: any) =>
  sendPost("/cms/admin-auth/login", payload);
export const getListMembers = () => sendGet("/cms/admin-auth/members");
